import { render, staticRenderFns } from "./modern-home-change-scene.vue?vue&type=template&id=4e29e80d&scoped=true&"
import script from "./modern-home-change-scene.vue?vue&type=script&lang=js&"
export * from "./modern-home-change-scene.vue?vue&type=script&lang=js&"
import style0 from "./modern-home-change-scene.vue?vue&type=style&index=0&id=4e29e80d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e29e80d",
  null
  
)

export default component.exports